var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployerIco3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2349_8897)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7454 35.6279C13.0244 35.6279 12.3402 35.5719 11.6962 35.4617L11.3147 35.3899C7.16541 34.5272 4.75391 31.3492 4.75391 26.5122V9.74368C4.75391 9.15918 4.78891 8.59918 4.85891 8.06368C5.46966 3.36493 8.69841 0.62793 13.7454 0.62793H27.2642C32.8572 0.62793 36.2014 3.98793 36.2539 9.60893V9.74368V26.5122C36.2539 32.2119 32.9009 35.6279 27.2642 35.6279H13.7454ZM13.7454 3.17768C9.44741 3.17768 7.26866 5.38793 7.26866 9.74368V26.5122C7.26866 30.8679 9.44741 33.0782 13.7454 33.0782H27.2484C31.5447 33.0782 33.7094 30.8679 33.7094 26.5122V9.74368C33.7094 5.38793 31.5447 3.17768 27.2484 3.17768H13.7454ZM28.0394 25.5374C28.0394 24.8374 27.4812 24.2704 26.7917 24.2704H14.1724C13.4829 24.2704 12.9229 24.8374 12.9229 25.5374C12.9229 26.2374 13.4829 26.8044 14.1724 26.8044H26.7917C27.4812 26.8044 28.0394 26.2374 28.0394 25.5374ZM26.7917 16.8522C27.2729 16.7997 27.7437 17.0307 28.0009 17.4454C28.2582 17.8637 28.2582 18.3922 28.0009 18.8104C27.7437 19.2252 27.2729 19.4562 26.7917 19.4037H14.1724C13.5319 19.3302 13.0472 18.7824 13.0472 18.1279C13.0472 17.4734 13.5319 16.9239 14.1724 16.8522H26.7917ZM20.1137 10.7272C20.1137 10.0727 19.6289 9.52318 18.9884 9.45143H14.1882C13.5459 9.52318 13.0612 10.0727 13.0612 10.7272C13.0612 11.3799 13.5459 11.9294 14.1882 12.0012H18.9884C19.6289 11.9294 20.1137 11.3799 20.1137 10.7272Z",
    fill: "#17B67C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2349_8897",
    x: 0.753906,
    y: 0.62793,
    width: 39.5,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2349_8897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2349_8897",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerIco3);
export default __webpack_public_path__ + "static/media/employer_ico_3.3066575c654d0d1958623081b6163a1f.svg";
export { ForwardRef as ReactComponent };